export default {
    data: function () {
        return {
            resultMsg: {
                Success: "感谢您的意见反馈，让我们能改进及更进步!!",
                Fail: "发送失败，请稍后重试!",
                Empty_Content: "意见栏位必须输入!",
            },
            feedbackContent: "",
            ContentMaxLength: 512,
        };
    },
    methods : {
        async AddFeedback() {
            let _this = this;
            if ( _this.feedbackContent.length === 0 ) {
                _this.$dialog.warning(_this.resultMsg.Empty_Content);
            }
            else if ( _this.feedbackContent.length > _this.ContentMaxLength ) {
                _this.$dialog.warning("意见最大长度为"+ _this.ContentMaxLength + "字符，请重新输入!");
            }
            else {
                try {
                    let result = await $.postJSON(`/api/Feedback/Add/`, { Comments: _this.feedbackContent });

                    if ( result.state ) {
                        _this.FeedBackSuccess();
                    }
                    else {
                        _this.$dialog.warning( result.text );
                    }
                }
                catch (err) {
                    console.error(err);
                    _this.FeedBackError();
                }
            }
        },
        FeedBackSuccess() {
            this.$dialog.warning(this.resultMsg.Success);
        },
        FeedBackError() {
            this.$dialog.warning(this.resultMsg.Fail);
        }
    }
}